import client from '../httpClient';

const resHouseDeleteApi = (pathParameter) => {
  return client.delete(`/inquiry-products/${pathParameter}`, { isShowMessage: true });
};

export default resHouseDeleteApi;
